import './DashbManagementPage.css';

import React, { useState } from 'react';
import Banner from '../../b2b-common/Banner';
import CustomButton from '../../b2b-common/CustomButton';
import { AddCircleOutline } from '@mui/icons-material';
import DashboardCard from '../components/DashboardCard';
import DashboardEditModal from '../forms/DashboardEditModal';
import { useNavigate } from 'react-router-dom';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import useGettingCustomDashboards from '../hooks/useGettingCustomDashboards';
import B2BElementsExplorerInMemory from '../../b2b-common/B2BElementsExplorerInMemory';

const DashbManagementPage = () => {
    const navigate = useNavigate();
    const { t } = useB2BTranslation('b2b-reporting');
    const { customDashboards, isLoading, refreshDashboards } = useGettingCustomDashboards();

    const [showDashbModal, setShowDashbModal] = useState(false);
    const [currentDashboard, setCurrentDashboard] = useState(null);

    const handleShowDashboardDetails = (dashboard) => {
        // console.log('handleShowDashboardDetails: ', dashboard);
        navigate(`/reporting/dashboards/${dashboard.dashboardId}`);
    }

    const handleEditDashboard = (dashboard) => {
        // console.log('handleEditDashboard: ', dashboard);
        setCurrentDashboard(dashboard);
        setShowDashbModal(true);
    }

    const handleDeleteDashboard = (dashboard) => {
        // console.log('handleDeleteDashboard: ', dashboard);
        setCurrentDashboard(null);
        refreshDashboards();
    }

    const handleSavedDashboard = (dashboard) => {
        // console.log('handleSavedDashboard: ', dashboard);
        setCurrentDashboard(null);
        refreshDashboards();
        setShowDashbModal(false);
    }

    const handleOnCancel = () => {
        setCurrentDashboard(null);
        setShowDashbModal(false);
    }

    return (
        <div className='dashboards-explorer-page'>
            <Banner message={t('Dashboards')} underline={false} headingLevel='h1' />
            <div className='dashboards-explorer-page-actions'>
                <CustomButton icon={<AddCircleOutline />} label={t('Create Dashboard')}
                    onClick={() => setShowDashbModal(true)}
                    rolesAllowed={['ADMIN', 'EDITOR']}
                    className='white_02'
                />
            </div>
            {customDashboards && customDashboards.length > 0 &&
                <B2BElementsExplorerInMemory
                    isSearching={isLoading}
                    elementsData={{content: customDashboards}}
                    className={'dashboards-explorer'}
                    ElementComponent={DashboardCard}
                    elementComponentPropName={'dashboard'}
                    elementComponentHandlers={{
                        onAccess: handleShowDashboardDetails,
                        onEdit: handleEditDashboard,
                        onDelete: handleDeleteDashboard
                    }}
                    numRows={customDashboards.length || 0}
                />
            }
            {(currentDashboard || (!currentDashboard && showDashbModal)) &&
                <DashboardEditModal
                    dashboard={currentDashboard} open={showDashbModal}
                    onSave={handleSavedDashboard}
                    onCancel={handleOnCancel} />
            }
        </div>
    );
};

export default DashbManagementPage;